export const ufDisplayNames = {
  NACIONAL: "Nacional",
  AC: "Acre",
  AL: "Alagoas",
  AP: "Amapá",
  AM: "Amazonas",
  BA: "Bahia",
  CE: "Ceará",
  DF: "Distrito Federal",
  ES: "Espírito Santo",
  GO: "Goiás",
  MA: "Maranhão",
  MT: "Mato Grosso",
  COMPLEMENTAR: "Mato Grosso",
  MS: "Mato Grosso do Sul",
  MG: "Minas Gerais",
  PA: "Pará",
  PB: "Paraíba",
  PR: "Paraná",
  PE: "Pernambuco",
  PI: "Piauí",
  RJ: "Rio de Janeiro",
  RN: "Rio Grande do Norte",
  RS: "Rio Grande do Sul",
  RO: "Rondônia",
  RR: "Roraima",
  SC: "Santa Catarina",
  SP: "São Paulo",
  SE: "Sergipe",
  TO: "Tocantins",
};

// Estados sem integração real no AgroReceita hoje — cards apenas informativos,
// com botão "Ver contato do órgão". Preencher os dados reais de contato em
// ORGAO_CONTACT_MAP conforme forem sendo levantados.
export const UNSUPPORTED_STATES = [
  { uf: "AC", sigla: "SISDAF", desc: "Envio de dados de receituários pelo <b>SISDAF</b> (Sistema de Defesa Agropecuária e Florestal). Órgão: IDAF-AC." },
  { uf: "AL", sigla: "ADEAL", desc: "Procure a <b>ADEAL</b> (Agência de Defesa e Inspeção Agropecuária de Alagoas) para detalhes sobre a fiscalização de receitas." },
  { uf: "AP", sigla: "DIAGRO", desc: "Procure a <b>DIAGRO</b> (Agência de Defesa e Inspeção Agropecuária do Amapá) para detalhes sobre a fiscalização de receitas." },
  { uf: "AM", sigla: "ADAF", desc: "Procure a <b>ADAF</b> (Agência de Defesa Agropecuária e Florestal do Amazonas) para detalhes sobre a fiscalização de receitas." },
  { uf: "CE", sigla: "ADAGRI", desc: "Procure a <b>ADAGRI</b> (Agência de Defesa Agropecuária do Estado do Ceará) para detalhes sobre a fiscalização de receitas." },
  { uf: "DF", sigla: "SEAGRI-DF", desc: "Procure a <b>SEAGRI-DF</b> (Defesa Agropecuária do Distrito Federal) para detalhes sobre a fiscalização de receitas." },
  { uf: "MA", sigla: "AGED", desc: "Procure a <b>AGED</b> (Agência Estadual de Defesa Agropecuária do Maranhão) para detalhes sobre a fiscalização de receitas." },
  { uf: "MS", sigla: "IAGRO", desc: "Procure a <b>IAGRO</b> (Agência Estadual de Defesa Sanitária Animal e Vegetal) para detalhes sobre a fiscalização de receitas." },
  { uf: "PA", sigla: "SIAPEC 3", desc: "Envio de dados de receituários pelo <b>SIAPEC 3</b> (Sistema de Integração Agropecuária). Órgão: ADEPARÁ." },
  { uf: "PB", sigla: "SEDAP-PB", desc: "Procure a <b>SEDAP-PB</b> (Defesa Agropecuária da Paraíba) para detalhes sobre a fiscalização de receitas." },
  { uf: "PE", sigla: "SIAPEC 3", desc: "Envio de dados de receituários pelo <b>SIAPEC 3</b> (Sistema de Integração Agropecuária). Órgão: ADAGRO." },
  { uf: "PI", sigla: "ADAPI", desc: "Procure a <b>ADAPI</b> (Agência de Defesa Agropecuária do Piauí) para detalhes sobre a fiscalização de receitas." },
  { uf: "RJ", sigla: "SIAPEC", desc: "Envio de dados de receituários pelo <b>SIAPEC</b> (Sistema de Integração Agropecuária). Órgão: SEAPEC-RJ." },
  { uf: "RN", sigla: "IDIARN", desc: "Procure o <b>IDIARN</b> (Instituto de Defesa e Inspeção Agropecuária do Rio Grande do Norte) para detalhes sobre a fiscalização de receitas." },
  { uf: "RO", sigla: "SIAFRO", desc: "Envio de dados de receituários pelo <b>SIAFRO</b> (Sistema de Fiscalização do Comércio de Agrotóxicos). Órgão: IDARON." },
  { uf: "RR", sigla: "ADERR", desc: "Procure a <b>ADERR</b> (Agência de Defesa Agropecuária de Roraima) para detalhes sobre a fiscalização de receitas." },
  { uf: "SE", sigla: "ADEMA-SE", desc: "Procure a <b>ADEMA-SE</b> (Administração Estadual de Meio Ambiente e Defesa Agropecuária) para detalhes sobre a fiscalização de receitas." },
  { uf: "TO", sigla: "ADAPEC", desc: "Procure a <b>ADAPEC</b> (Agência de Defesa Agropecuária do Estado do Tocantins) para detalhes sobre a fiscalização de receitas." },
];

// Sites oficiais levantados via busca; sem telefone/e-mail (não verificados o suficiente
// pra exibir com confiança). RN (IDIARN) ficou de fora por não ter um site oficial confiável.
export const ORGAO_CONTACT_MAP = {
  AC: { site: "https://idaf.ac.gov.br/" },
  AL: { site: "https://www.defesaagropecuaria.al.gov.br/" },
  AP: { site: "http://www.diagro.ap.gov.br/" },
  AM: { site: "https://www.adaf.am.gov.br/" },
  CE: { site: "https://www.adagri.ce.gov.br/" },
  DF: { site: "https://seagri.df.gov.br/" },
  MA: { site: "https://www.aged.ma.gov.br/" },
  MS: { site: "https://www.iagro.ms.gov.br/" },
  PA: { site: "https://www.adepara.pa.gov.br/" },
  PB: { site: "https://paraiba.pb.gov.br/diretas/secretaria-de-desenvolvimento-da-agropecuaria-e-pesca/defesa-agropecuaria" },
  PE: { site: "https://www.adagro.pe.gov.br/" },
  PI: { site: "http://www.adapi.pi.gov.br/" },
  RJ: { site: "https://www.rj.gov.br/agricultura/" },
  RO: { site: "https://www.idaron.ro.gov.br/" },
  RR: { site: "https://aderr.rr.gov.br/" },
  SE: { site: "https://adema.se.gov.br/" },
  TO: { site: "https://www.to.gov.br/adapec" },
};
